import { Component, OnInit } from '@angular/core';
import { LineGroupService } from '../../_services/linegroup.service';

@Component({
    selector: 'app-linegroup',
    templateUrl: './linegroup.component.html',
    styleUrls: ['./linegroup.component.css']
})
export class LineGroupComponent implements OnInit {
    model: any = {};
    loading: boolean = false;
    message: string = '';
    constructor(private lineGroupService:LineGroupService) { }

    ngOnInit() {
        this.lineGroupService.gets().subscribe(data => {
            if (data.length) {
                this.model.groupid = data[0].group_id;
            }
        }, error => {
            this.message = error;
        });
    }

    save() {
        this.message = '';
        this.loading = true;
        this.lineGroupService.save(this.model).subscribe(data => {
            this.loading = false;
            this.message = '保存成功！';

        }, error => {
            this.message = error.json().message;
            this.loading = false;
        })
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/linegroup/linegroup.component.ts